import { WidgetCellElement } from '../cellElements';
import { CSS } from '../../../const';
import { IUIElementOptions } from '../../../interfaces/options';
import { DEFAULTUIELEMENTOPTIONS } from '../../../const/defaultOptions';

export class BaseUIElement {
	public id: string;
	public visible: KnockoutObservable<boolean>;
	protected css: KnockoutComputed<string>;
	protected size: KnockoutObservable<string>;
	protected widget: WidgetCellElement<any>;
	private hasLOffset: boolean;
	private hasROffset: boolean;
	private lOffset: string;
	private rOffset: string;
	private template: KnockoutObservable<string>;
	public constructor(id: string, label: string, options?: IUIElementOptions) {
		options = $.extend(true, {}, DEFAULTUIELEMENTOPTIONS, options || {});
		this.id = id;
		this.template = ko.observable<string>(options.template);
		this.size = ko.observable<string>(options.size);
		this.visible = ko.isObservable(options.visible)
			? <KnockoutObservable<boolean>>options.visible
			: ko.observable(<boolean>options.visible);
		this.widget = new WidgetCellElement<any>(
			this,
			null,
			ko.pureComputed(() => true),
			options.widget
		);
		//widgetname == filename
		let widgetFileSegments = options.widget.widget.split('_');
		this.css = ko.pureComputed(() => {
			var css = CSS.WidgetWrapper.concat(
				' ',
				widgetFileSegments[widgetFileSegments.length - 1],
				' ',
				CSS.CellX.concat(this.size())
			);
			if (options.css) {
				return css.concat(' ', typeof options.css === "string" ? options.css : options.css());
			}
			return css;
		});
		this.hasLOffset = false;
		this.hasROffset = false;
		this.lOffset = null;
		this.rOffset = null;
		if (options.offset) {
			if (options.offset.left) {
				this.hasLOffset = true;
				this.lOffset = CSS.CellX.concat(options.offset.left);
			}
			if (options.offset.right) {
				this.hasROffset = true;
				this.rOffset = CSS.CellX.concat(options.offset.right);
			}
		}
	}
	public setWidget(widget: string) {
		this.widget.widget(widget);
	}
	public setSize(size: string) {
		this.size(size);
	}
}
